module.exports = __webpack_public_path__ + "img/gmail.ff629c02.png";